module.exports = __webpack_public_path__ + "static/media/editicon.9595d23b.png";